import i18next from 'i18next';
import { RestClientNetworkError } from 'web-app/api/clients/rest-client-network-error';
/**
 * The reason the backend gave for a failed call, such as a wrong PIN, for showing to the person
 * at the kiosk. The sign-in app's REST client only logs failures, so without this they see nothing.
 */
export const getRestClientErrorMessage = (error) => {
    var _a;
    const backendMessage = error instanceof RestClientNetworkError ? (_a = error.response) === null || _a === void 0 ? void 0 : _a.error : undefined;
    return typeof backendMessage === 'string' && backendMessage !== ''
        ? backendMessage
        : i18next.t($ => $.somethingWentWrong);
};
